import { Component, OnDestroy } from '@angular/core';
import { Subject, MonoTypeOperatorFunction, takeUntil } from 'rxjs';
import { OktaAuthService } from 'src/app/core/services/http/okta-auth.service';
import { OktaUser } from '../models/okta-user';

@Component({
    template: '',
    standalone: false
})
export default class BaseComponent implements OnDestroy {
    protected unsubscribe: Subject<any> = new Subject<any>();
    protected oktaUser: OktaUser;
    public isGlobalAdmin = false;

    public unsubscribeOnDestroy = <T>(): MonoTypeOperatorFunction<T> => takeUntil<T>(this.unsubscribe);

    constructor(oktaAuth?: OktaAuthService) {
        if (oktaAuth) {
            oktaAuth.getUser().then(user => (this.oktaUser = user));
            this.isGlobalAdmin = oktaAuth.isGlobalAdmin();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe.next(true);
        this.unsubscribe.complete();
    }
}
